export default __webpack_public_path__ + "static/media/Img_NewFindYourJoy_LandingPage.b699a1f5.png";